import React, { useEffect } from 'react'
import { useStore, authStoreId } from 'stores'
import { useI18next } from 'gatsby-plugin-react-i18next'
import { getPathWithoutLocale } from 'libs/router/routeHelper'
import { languages } from 'assets/languages'

const excludesPath = [
  '/login/',
  '/signup/',
  '/signup/email-verify/',
  '/signup/success/',
  '/forget-password/',
  '/forget-password/success/',
  '/reset-password/',
  '/reset-password/success/',
  '/privacy/',
  '/terms/',
  '/'
]

const AuthRedirection = ({ children, location, pageContext }) => {
  const authStore = useStore(authStoreId)
  const { navigate } = useI18next()
  useEffect(() => {
    // BUGS: gatsby-i18n-plugin has bugs when component located in gatsby-ssr.js
    const { language } = pageContext.i18n
    const { pathname, search } = location
    const path = getPathWithoutLocale(pathname, languages)
    const found = excludesPath.find(excludePath => excludePath === path)

    if (!found && !authStore.getters.isLoggedIn()) {
      const target = `${pathname}${search}`
      navigate(`/${language}/login/?target=${target}`)
    }
  }, [location, authStore.getters.isLoggedIn()])

  return (
    <>
      {children}
    </>
  )
}

export default AuthRedirection